import request from '@/utils/request'

/**
 * 添加菜单
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuAdd(data) {
  return request({
    type: 'base',
    url: 'menu/add',
    method: 'post',
    data
  })
}
/**
 * 删除菜单
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuDelete(data) {
  return request({
    type: 'base',
    url: 'menu/delete',
    method: 'post',
    data
  })
}
/**
 * 获取菜单详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuGet(data) {
  return request({
    type: 'base',
    url: 'menu/get',
    method: 'post',
    data
  })
}
/**
 * 获取菜单列表（不区分用户权限）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuListGet(data) {
  return request({
    type: 'base',
    url: 'menu/list/get',
    method: 'post',
    data
  })
}
/**
 * 一二级菜单下拉列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuOptionListGet(data) {
  return request({
    type: 'base',
    url: 'menu/option/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取用户选中菜单列表（新增编辑角色时使用）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuSelfListGet(data) {
  return request({
    type: 'base',
    url: 'menu/self/list/get',
    method: 'post',
    data
  })
}
/**
 * 修改菜单排序
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuSortUpdate(data) {
  return request({
    type: 'base',
    url: 'menu/sort/update',
    method: 'post',
    data
  })
}
/**
 * 修改菜单排序（新）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuSortUpdateNew(data) {
  return request({
    type: 'base',
    url: 'menu/sort/update/new',
    method: 'post',
    data
  })
}
/**
 * 获取一级菜单列表（隐藏或不隐藏菜单传入条件）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuTopListGet(data) {
  return request({
    type: 'base',
    url: 'menu/top/list/get',
    method: 'post',
    data
  })
}
/**
 * 修改菜单
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function menuUpdate(data) {
  return request({
    type: 'base',
    url: 'menu/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Menu.js